<template>
  <div class="homepage-wrapper">
    <data-loader  :is_on="loading_data"></data-loader>
    <div class="year-picker">
      <!-- <label class="form-label">
        <span>{{ $t("forms.cost_sheet.breakdown.form.idx") }}</span>
      </label> -->
      <custom-dropdown
        :id="'drop_sifarnik_type'"
        v-model="chosen_year"
        :drop_items="years"
      />
    </div>

    <div class="home-top-row" v-if="analytics_data">
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t("page_1.row_1.box_1") }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{analytics_data.not_archived}}</div>
        </div>
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t("page_1.row_1.box_2") }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{analytics_data.archived  }}</div>
        </div>
        
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('analytics.in_house') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{analytics_data.ih_cases_length}}</div>
        </div>
        
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('analytics.total_events') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{analytics_data.all_events}}</div>
        </div>
        
      </div>
      <div class="predmeti-zadaci-box section">
        <div class="predmeti-zadaci-title">{{ $t('analytics.resolved_events') }}</div>
        <div class="predmeti-zadaci-number">
          <div class="zadaci-number">{{analytics_data.finished_events}}</div>
        </div>
        
      </div>
      
    </div>
    <div class="line-chartwrapper">
      <div class="first chart-wrapper" id="graph-container">
        <canvas id="billingChart"></canvas>
        
      </div>
      <div class="vertical-top-five-list">
        <div class="aktualni-predmeti section">
          <div class="inside-title">{{ $t('analytics.physical_persons') }}</div>
            <!-- <div class="activity-navigation">
              <div class="activity-navigation-left">
                <div class="mab latest-activity-button">{{ $t('page_1.row_3.box_1.latest_activity') }} <img class="mab-icon"
                    src="@/assets/img/latest_activity.svg" /></div>
                <div class="snb small-navigation-button" @click="active_predmeti = true"
                  :class="[active_predmeti ? 'active' : '', 'aktualni-title']"><img class="mab-sm-icon mab-sm-first"
                    src="@/assets/img/cases_blue.svg" /></div>
                <div class="snb small-navigation-button" @click="active_predmeti = false"
                  :class="[!active_predmeti ? 'active' : '', 'aktualni-title']"><img class="mab-sm-icon"
                    src="@/assets/img/projects_blue.svg" /></div>
              </div>
              <div class="activity-navigation-right">
                <div class="mab my-cases-button"
                  @click="$store.state.view_cases_by_logged_person = true; $router.push('/cases')">
                  {{ $t('page_1.row_3.box_1.my_cases') }}<img class="mab-icon" src="@/assets/img/cases_blue.svg" /></div>
                <div class="mab my-projects-button"
                  @click="$store.state.view_cases_by_logged_person = true; $router.push('/projects')">
                  {{ $t('page_1.row_3.box_1.my_projects') }}<img class="mab-icon" src="@/assets/img/projects_blue.svg" />
                </div>
              </div>
            </div> -->

            <!-- <div v-if="fetching" class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div> -->
            <div  class="cases-main-wrapper">
              <div class="cases-row row-title-row">
                <div class="cases-column cases-column1" style="opacity: 1 !important">
                  Br.
                </div>
                <div class="cases-column cases-column2" style="opacity: 1 !important; transform: none !important">
                  Naziv
                </div>
                <div v-show="!active_predmeti" class="cases-column cases-column3">
                   Uk. predmeta
                </div>
                <div class="cases-column cases-column4">
                 {{ $t('analytics.last_activity') }}
                </div>
              </div>
            
              <div  class="cases-inner-wrapper" v-if="analytics_data">
                <div class="cases-row" v-for="(priv,key) in analytics_data.top_private" :key="key">
                  <div class="cases-column cases-column1">
                    #{{ key+1 }}
                  </div>
                  <div class="cases-column cases-column2">
                    {{priv.ime}} {{ priv.prezime }}
                  </div>
                  <div class="cases-column cases-column3">
                    {{priv.connect_fiz_stranka.length}}
                    
                  </div>
                  <div class="cases-column cases-column4">
                    <span v-if="priv.connect_fiz_stranka.length > 0">
                     {{getTimestamp(priv.connect_fiz_stranka[0].predmet.case_log[0].timestamp)}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="aktualni-predmeti section">
          <div class="inside-title">{{ $t('analytics.legal_entities') }}</div>
            <!-- <div class="activity-navigation">
              <div class="activity-navigation-left">
                <div class="mab latest-activity-button">{{ $t('page_1.row_3.box_1.latest_activity') }} <img class="mab-icon"
                    src="@/assets/img/latest_activity.svg" /></div>
                <div class="snb small-navigation-button" @click="active_predmeti = true"
                  :class="[active_predmeti ? 'active' : '', 'aktualni-title']"><img class="mab-sm-icon mab-sm-first"
                    src="@/assets/img/cases_blue.svg" /></div>
                <div class="snb small-navigation-button" @click="active_predmeti = false"
                  :class="[!active_predmeti ? 'active' : '', 'aktualni-title']"><img class="mab-sm-icon"
                    src="@/assets/img/projects_blue.svg" /></div>
              </div>
              <div class="activity-navigation-right">
                <div class="mab my-cases-button"
                  @click="$store.state.view_cases_by_logged_person = true; $router.push('/cases')">
                  {{ $t('page_1.row_3.box_1.my_cases') }}<img class="mab-icon" src="@/assets/img/cases_blue.svg" /></div>
                <div class="mab my-projects-button"
                  @click="$store.state.view_cases_by_logged_person = true; $router.push('/projects')">
                  {{ $t('page_1.row_3.box_1.my_projects') }}<img class="mab-icon" src="@/assets/img/projects_blue.svg" />
                </div>
              </div>
            </div> -->

            <!-- <div v-if="fetching" class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div> -->
            <div  class="cases-main-wrapper">
              <div class="cases-row row-title-row">
                <div class="cases-column cases-column1" style="opacity: 1 !important">
                  Br.
                </div>
                <div class="cases-column cases-column2" style="opacity: 1 !important; transform: none !important">
                  Naziv
                </div>
                <div v-show="!active_predmeti" class="cases-column cases-column3">
                    Uk. predmeta
                </div>
                <div class="cases-column cases-column4">
                Zadnja aktivnost
                </div>
              </div>
            
              <div  class="cases-inner-wrapper" v-if="analytics_data">
                <div class="cases-row" v-for="(priv,key) in analytics_data.top_public" :key="key">
                  <div class="cases-column cases-column1">
                    #{{ key+1 }}
                  </div>
                  <div class="cases-column cases-column2">
                    {{priv.ime}}
                  </div>
                  <div class="cases-column cases-column3">
                    {{priv.prav_connect_stranka.length}}
                    
                  </div>
                  <div class="cases-column cases-column4">
                    <span v-if="priv.prav_connect_stranka.length > 0">
                      {{priv.prav_connect_stranka[0].predmet.case_log[0].timestamp}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import CustomDropdown from '../../../../components/generalComponents/CustomDropdown.vue';
import {getAnalytics} from "../../../../apiCallers/promise_handler_db/analytics"
import moment from "moment"
import $ from "jquery"
import DataLoader from '../../../../components/generalComponents/DataLoader.vue';
export default {
  components: { CustomDropdown, DataLoader },
  data() {
    return {
      chart: null,
      chosen_year: parseInt(new Date().getFullYear()),
      years: [],
      analytics_data : null,
      start_year: 2000,
      loading_data : true
    };
  },
  mounted() {
    this.initYears();
    this.$store.state.paginacija.title = this.$t("breadcrumbs.statistics");
    this.refreshData()
    

  },
  watch:{
    chosen_year(){
      this.refreshData();
    }
  },
  computed: {},
  methods: {
    getTimestamp(ts_date){
      return moment(ts_date).format("lll")
    },
    async refreshData(){
      this.loading_data = true;
      let tmp_data= await getAnalytics(this.chosen_year);
      this.analytics_data = tmp_data.data;
      console.log("Analytics data", tmp_data);
      this.renderChart()
      this.loading_data = false;
    },
    initYears() {
      console.log();
      const yr = parseInt(new Date().getFullYear());
      for (let i = yr; i >= this.start_year; i--) {
        this.years.push({
              naziv: i,
              id: i,
            });
      }
    },
    formatCurrency(value) {
      // Format numbers as currency with the € symbol after the number
      return `${Number(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} €`;
    },
    renderChart() {
      $('#billingChart').remove(); // this is my <canvas> element
      $('#graph-container').append('<canvas id="billingChart"><canvas>');
      const ctx = document.getElementById("billingChart").getContext("2d");
      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.analytics_data.graph_struct.labels,
          datasets: this.analytics_data.graph_struct.datasets,
        },
        options: {
          responsive: true,
          width: "600px",
          interaction: {
            mode: "index",
            intersect: true,
          },
          stacked: false,
          plugins: {
            title: {
              display: true,
              text: this.$t('analytics.billing_for_year'),
            },
          },
          scales: {
            y: {
              type: "linear",
              display: true,
              position: "left",
            },
            y1: {
              type: "linear",
              display: true,
              position: "right",

              // grid line settings
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
          },
        },
      });
    },
  },
};
</script>
